import { render, staticRenderFns } from "./BilanDepenseBenefice.vue?vue&type=template&id=c02980ea"
import script from "./BilanDepenseBenefice.vue?vue&type=script&lang=js"
export * from "./BilanDepenseBenefice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports